import React from 'react';

import { Client } from '@netfront/gelada-react-shared';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import QueryRequest from '../QueryRequest';

export const GET_ORG_INVITATION_LIST_REQUEST = gql`
  query getOrgInvitationListRequest($orgId: Int!) {
    invitation {
      getInvitationsWithinOrganisation(organisationId: $orgId) {
        id
        invitedUserEmail: emailUserInvited
        organisationId
        firstName
        lastName
        permission
        __typename
      }
      __typename
    }
  }
`;

const getOrgInvitationListRequest = ({
  orgId,
  onError,
  onSuccessResult,
  // pending,
}) => (
  <Query
    client={Client()}
    fetchPolicy="network-only"
    query={GET_ORG_INVITATION_LIST_REQUEST}
    variables={{ orgId }}
  >
    {({ loading, error, data }) => (
      <QueryRequest
        data={
          data &&
          Object.entries(data).length !== 0 &&
          data.invitation.getInvitationsWithinOrganisation
        }
        error={error}
        isLoading={loading}
        onError={onError}
        onSuccessResult={onSuccessResult}
      />
    )}
  </Query>
);

getOrgInvitationListRequest.propTypes = {
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  orgId: PropTypes.number.isRequired,
  // eslint-disable-next-line react/boolean-prop-naming
  // pending: PropTypes.bool,
};

getOrgInvitationListRequest.defaultProps = {
  // pending: true,
};

export default getOrgInvitationListRequest;
